import React from 'react'
import MyOrder from '../Components/MyOrder/MyOrder'
import RelatedProducts from "../Components/RelatedProducts/RelatedProducts"

const Orders = () => {
  return (
    <div>
      <MyOrder/>
      <RelatedProducts />
    </div>
  )
}

export default Orders